export interface BundleChild {
  variantId: number;
  sellingPlanId?: number;
  maxAmountInCart?: number;
}
export interface RefillBundleChild {
  parent_variant_id: number;
  refill_variant_id?: number;
  selling_plan_id?: number;
  disable_selling_plan_when_refill: boolean;
}
export interface BundleChildRaw {
  variant_id: number;
  selling_plan_id?: number;
  max_amount_in_cart?: number;
}

export function fromBundleChildRaw(raw: BundleChildRaw): BundleChild {
  return {
    variantId: raw.variant_id,
    sellingPlanId: raw.selling_plan_id,
    maxAmountInCart: raw.max_amount_in_cart,
  };
}

export function isBundleChildRaw(i: unknown): i is BundleChildRaw {
  if (typeof i !== 'object' || i === null) {
    return false;
  }
  return typeof (i as BundleChildRaw).variant_id === 'number';
}
